"use client";

import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import Image from "next/image";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="grid h-screen w-screen place-items-center">
          <div className="flex flex-col items-center gap-4">
            <div className="flex flex-row items-center gap-2">
              <Image
                src="/dealpage.png"
                alt="Paige"
                width={25}
                height={25}
                className="rounded-md"
              />
              <p className="font-semibold">Something went wrong!</p>
            </div>
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </div>
        </div>
      </body>
    </html>
  );
}
